import React from 'react';
import PropTypes from 'prop-types';

import Badge from '../../../components/Badge/Badge';
import ButtonTypes from '../../../constants/buttonTypes';
import logActionType from '../../../constants/logActionType';

const ActionType = ({ type }) => {
  const badgeType = {
    [logActionType.CREATE]: ButtonTypes.LIGHT_PRIMARY,
    [logActionType.UPDATE]: ButtonTypes.LIGHT_WARNING,
    [logActionType.DELETE]: ButtonTypes.LIGHT_DANGER,
    [logActionType.PRINT]: ButtonTypes.LIGHT_PRIMARY
  };

  return <Badge text={type} type={badgeType[type]} />;
};

ActionType.propTypes = {
  type: PropTypes.string
};

ActionType.defaultProps = {
  type: ''
};

export default ActionType;
